import React, { Component } from 'react';
import * as $ from 'jquery';
import RoomSearch from './RoomSearch.js';
import Rooms from './Rooms.js';
import axios from 'axios';
import moment from 'moment-timezone';
import { MENU } from '../Sidebar.js';
import { Redirect } from 'react-router-dom';
import { translate } from 'react-i18next';
import HorasReservaciones from '../../components/Balance/HorasReservaciones';

export const ROOM_TYPE = {
  MEETING_ROOM: "1",
  COWORK: "2"
};

let cancelToken;
let state;
let tokenSession;
let arrDates = []
class RoomsContainer extends Component {

  constructor(props) {
    super(props);

    if (tokenSession !== props.getTokenSession()) {
      state = this.getInitState();
    }

    if (props.center) {
      state.center = props.center;
      state.centerQuery = props.centerQuery;
      state.centers = props.centers;
    }

    state.reservationId = "";
    this.state = state;
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();

    this.getProfile({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
    state = this.state;
    tokenSession = this.props.getTokenSession();
  }

  bookRoom = (params) => {
    this.props.post(
      "/bookRoom",
      params,
      (response) => this.didBookRoom(response),
      (error) => this.didBookRoomError(error),
      cancelToken
    );
  }

  didBookRoomError = (error) => {
    const { t } = this.props;
    alert(t('dashboard.reservations.msg'));
  }

  didBookRoom = (response) => {
    this.setState({ reservationId: response.reservation_id });
  }

  didGetCenters = (response) => {
    this.setState({ centers: response });

    this.handleOptionUpdate();
  }

  didGetDurations = (response) => {
    let duration = this.state.duration;
    duration = duration ? duration : response[0].id;
    this.setState({
      duration: duration,
      durations: response
    });
  }

  didGetProfile = (response) => {
    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    this.props.user.balance = response.balance;
    this.props.user.credits = response.credits;
    this.setState({
      isTomorrow: moment(tomorrow),
      center: response.center,
      date: moment(tomorrow, 'MM/DD/YYYY').format('MM/DD/YYYY'),
      centerQuery: response.center_name,
      empresa_id: response.empresa_id
    })
    this.reload();
  }

  didGetRooms = (response) => {
    const { t } = this.props;

    const callback = () => {
      if (this.state.rooms.length > 0) {
        $('html, body').animate({
          scrollTop: $('#rooms').offset().top - $('.navbar').height() - 20
        }, 800);
      } else {
        this.setState({ error: t('dashboard.reservations.no_results') });
      }
    };

    if(response.validate_dia) {
      this.setState({ 
        isSearching: false,
        error: t('dashboard.reservations.validate_day') 
      });
      return;
    }

    this.setState({
      isSearching: false,
      rooms: Object.values(response).map((r) => {

        r.room_type = this.state.roomType;
        return r;
      }),
      search: {
        center: this.state.center ? this.state.center : this.props.center,
        date: this.state.date,
        duration: this.state.duration,
        time: this.state.time
      }
    }, callback);
  }

  getHours = (params) => {
    this.props.post(
      "/gethours",
      params,
      (response) => this.didGetHours(response),
      (error) => this.handleErrorHoursResponse(error),
      cancelToken
    );
  }

  handleErrorHoursResponse = (error) => {

  }

  didGetHours = (response) => {
    this.setState({
      SaldoTotal: response.SaldoTotal,
      TotalHrsChicas: response.TotalHrsChicas,
      TotalHrsChicasDisponibles: response.TotalHrsChicasDisponibles,
      TotalHrsGrandes: response.TotalHrsGrandes,
      TotalHrsGrandesDisponibles: response.TotalHrsGrandesDisponibles,
      TotalHrsEspecialesGrandesDisponibles: response.TotalHrsEspecialesGrandesDisponibles,
      TotalHrsEspecialesChicasDisponibles: response.TotalHrsEspecialesChicasDisponibles,
      hrsChicasUtilizadas: response.hrsChicasUtilizadas,
      hrsGrandesUtilizadas: response.hrsGrandesUtilizadas,
      hrsEspecialesGrandesUtilizadas: response.hrsEspecialesGrandesUtilizadas,
      hrsEspecialesChicasUtilizadas: response.hrsEspecialesChicasUtilizadas
    })
  }

  getCenters = (params) => {
    this.props.post(
      "/getCenters",
      params,
      (response) => this.didGetCenters(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  handleOptionUpdate = () => {
    if ($("#center-results").children().length) {
      $("#center-results").css("display", "");
    } else {
      $("#center-results").css("display", "none");
    }
  }

  getDurations = (params) => {
    this.props.post(
      "/getDurations",
      params,
      (response) => this.didGetDurations(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  getProfile = (params) => {
    this.props.post(
      "/getProfileUser",
      params,
      (response) => this.didGetProfile(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  getInitState = () => {
    return {
      centerId: "",
      center: null,
      centerQuery: "",
      centers: [],
      date: "",
      duration: "",
      durations: [],
      error: "",
      isTomorrow: "",
      isSearching: false,
      reservationId: "",
      room: null,
      roomType: ROOM_TYPE.MEETING_ROOM,
      coworkType: 1,
      numDays: 0,
      dateCowork: '',
      listDate: [],
      rooms: [],
      search: null,
      time: "08:00",
      SaldoTotal: "",
      TotalHrsChicas: "",
      TotalHrsChicasDisponibles: "",
      TotalHrsGrandes: "",
      TotalHrsGrandesDisponibles: "",
      TotalHrsEspecialesGrandesDisponibles: "",
      TotalHrsEspecialesChicasDisponibles: "",
      hrsChicasUtilizadas: "",
      hrsGrandesUtilizadas: "",
      hrsEspecialesGrandesUtilizadas: "",
      hrsEspecialesChicasUtilizadas: "",
    };
  }

  getRooms = (params) => {
    this.props.post(
      "/getRooms",
      params,
      (response) => this.didGetRooms(response),
      (error) => {
        this.setState({ isSearching: false });
        this.props.handleErrorResponse(error);
      },
      cancelToken,
      () => this.setState({ isSearching: false })
    );
  }

  handleCenterClick = (center) => {
    this.setState({
      center: center,
      centerQuery: center.name
    });
  }

  handleCenterSearch = (event) => {
    const getCenters = () => this.getCenters({
      query: this.state.centerQuery,
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });

    this.setState({
      center: null,
      centerQuery: event.target.value
    }, getCenters);
  }

  handleClearError = () => {
    this.setState({ error: "" });
  }

  handleDateChange = (date) => {
    const new_date = moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY')
    this.setState({ date: new_date });
  }

  handleDurationChange = (event) => {
    this.setState({ duration: event.target.value });
  }

  handleRoomClick = (room) => {
    const bookRoom = () => this.bookRoom(Object.assign({},
      this.state.search,
      { id: room.id },
      { date: moment(this.state.search.date, 'MM/DD/YYYY').format('YYYY-MM-DD') },
      { room_type: room.room_type },
      { token_id: this.props.getTokenId() },
      { token_session: this.props.getTokenSession() },
      { listDate: this.state.listDate },
      { days: this.state.numDays },
      { typeCowork: this.state.coworkType }
    ));
    this.setState({ room: room }, bookRoom);
  }

  handleRoomSearch = (event) => {
    event.preventDefault();

    this.setState({
      error: "",
      isSearching: true
    });

    this.getRooms({
      center_id: this.state.center ? this.state.center.id : this.props.center.id,
      date: moment(this.state.date, 'MM/DD/YYYY').format('YYYY-MM-DD'),
      duration: this.state.duration,
      room_type: this.state.roomType,
      time: this.state.time,
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });
  }

  // Select space type
  handleRoomType = (event) => {
    this.setState({ roomType: event.target.value });
  }

  // Radio Button cowork type
  handleRadioButton = (event) => {
    this.setState({ coworkType: event.target.value });
    if (event.target.value === 2) {
      this.setState({ numDays: 1 })
    } else {
      this.setState({ numDays: 0 })
    }
  }

  // num days cowork
  handleSelectCowork = (event) => {
    this.setState({ numDays: event.target.value })
  }

  // change timepickers
  handleDateChangeCowork = (date, inputChange) => {
    arrDates.push(moment(date, 'MM/DD/YYYY').format('YYYY-MM-DD'));
    this.setState({ listDate: arrDates });
  }

  handleTimeChange = (event) => {
    this.setState({ time: event.target.value });
  }

  reload = () => {
    this.getDurations({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    });

    this.getHours({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
      empresa_id: this.state.empresa_id
    });
  }

  renderRoomSearch = () => {
    return (
      <RoomSearch
        center={this.state.center ? this.state.center : this.props.center}
        centerQuery={this.state.centerQuery ? this.state.centerQuery : this.props.centerQuery}
        centers={this.state.centers}
        date={this.state.date}
        duration={this.state.duration}
        durations={this.state.durations}
        error={this.state.error}
        handleCenterClick={this.handleCenterClick}
        handleCenterSearch={this.handleCenterSearch}
        handleDateChange={this.handleDateChange}
        handleDurationChange={this.handleDurationChange}
        handleClearError={this.handleClearError}
        handleRoomSearch={this.handleRoomSearch}
        handleRoomType={this.handleRoomType}
        handleRadioButton={this.handleRadioButton}
        handleTimeChange={this.handleTimeChange}
        handleSelectCowork={this.handleSelectCowork}
        handleDateChangeCowork={this.handleDateChangeCowork}
        isSearching={this.state.isSearching}
        roomType={this.state.roomType}
        coworkType={this.state.coworkType}
        numDays={this.state.numDays}
        objInputsCowork={this.state}
        rooms={this.state.rooms}
        time={this.state.time} />
    );
  }

  renderRooms = () => {
    return (
      <Rooms
        center={this.state.search ? this.state.search.center : null}
        handleRoomClick={this.handleRoomClick}
        rooms={this.state.rooms}
        user={this.props.user} />
    );
  }

  render() {
    if (this.state.reservationId) {
      return <Redirect push to={{
        pathname: (this.props.user.no_account ? "/store" : "") + "/reservations/" + this.state.reservationId,
        state: {
          center: JSON.stringify(this.state.search.center),
          reservationId: this.state.reservationId,
          room: JSON.stringify(this.state.room)
        }
      }} />;
    }

    const isMember = this.props.user.member !== 3;
    const { t } = this.props;
    const permissionStatus = this.props.getPermissionStatus(MENU.RESERVATIONS);
    return (
      <div className="content-resvations">
        <div className="">
          <div className="">
            <h2 className="page-header">{t('dashboard.reservations.heading')}</h2>
          </div>
          {this.props.user.memberId
            ? (
              <div className='contHoras'>
                <HorasReservaciones
                  tipoDeSala={t('dashboard.reservations.big_remaining')}
                  horasDisponibles={this.state.TotalHrsGrandesDisponibles || 0}
                  horasUsadas={this.state.hrsGrandesUtilizadas || 0}
                >
                </HorasReservaciones>
                <HorasReservaciones
                  tipoDeSala={t('dashboard.reservations.special_big_remaining')}
                  horasDisponibles={this.state.TotalHrsEspecialesGrandesDisponibles || 0}
                  horasUsadas={this.state.hrsEspecialesGrandesUtilizadas || 0}
                >
                </HorasReservaciones>
                <HorasReservaciones
                  tipoDeSala={t('dashboard.reservations.small_remaining')}
                  horasDisponibles={this.state.TotalHrsChicasDisponibles || 0}
                  horasUsadas={this.state.hrsChicasUtilizadas || 0}
                >
                </HorasReservaciones>
                <HorasReservaciones
                  tipoDeSala={t('dashboard.reservations.special_small_remaining')}
                  horasDisponibles={this.state.TotalHrsEspecialesChicasDisponibles || 0}
                  horasUsadas={this.state.hrsEspecialesChicasUtilizadas || 0}
                >
                </HorasReservaciones>
              </div>
            )
            : null
          }
        </div>
        {isMember ? (
          <div>
            {permissionStatus && <div className="jumbotron alert-warning">{permissionStatus}</div>}
            {!permissionStatus &&
              <div>
                <div className="content-resvations-search">
                  {this.renderRoomSearch()}
                </div>
                <div className="content-resvations-content">
                  <div id="rooms">{this.renderRooms()}</div>
                </div>
              </div>
            }
          </div>
        ) : (
          <div>
            {permissionStatus && <div className="jumbotron alert-warning">{permissionStatus}</div>}
            {!permissionStatus &&
              <div>
                <div className="content-resvations-search">
                  {this.renderRoomSearch()}
                </div>
                <div className="content-resvations-content">
                  <div id="rooms">{this.renderRooms()}</div>
                </div>
              </div>
            }
          </div>
        )

        }
      </div>
    );
  }
}

export default translate('common')(RoomsContainer);



// WEBPACK FOOTER //
// ./src/dashboard/reservations/RoomsContainer.js